<template>
  <el-card>
    <el-row class="inviteMgr__title">邀请绑定</el-row>
    <el-row class="inviteMgr__search">
      <span>邀请方:</span>
      <el-input
        type="text"
        style="width: 200px"
        v-model="search.rid"
        placeholder="请输入rid"
      />
      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="getInfo(search.rid, 0)"
        >search</el-button
      >
      <div class="avatar">
        <img :src="userInfo.head" alt="" />
      </div>
      <div class="name">{{ userInfo.name }}</div>
    </el-row>
    <el-row class="inviteMgr__search">
      <span>被邀请方:</span>
      <el-input
        type="text"
        style="width: 200px"
        v-model="search.inviteRid"
        placeholder="请输入rid"
      />
      <el-button
        type="primary"
        style="margin-left: 10px"
        @click="getInfo(search.inviteRid, 1)"
        >search</el-button
      >
      <div class="avatar">
        <img :src="userInfo.inviteHead" alt="" />
      </div>
      <div class="name">{{ userInfo.inviteName }}</div>
    </el-row>
    <el-row>
      <h1 style="margin-left: 18px">{{ msg }}</h1>
    </el-row>
    <el-row>
      <el-popconfirm title="确认绑定？" @confirm="bind">
        <el-button type="primary" slot="reference">确定</el-button>
      </el-popconfirm>
    </el-row>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      search: {
        rid: null,
        inviteRid: null,
      },
      userInfo: {
        head: '',
        name: '',
        inviteHead: '',
        inviteName: '',
      },
      msg: '',
    }
  },
  methods: {
    async getInfo(rid, type) {
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.invite_mgr_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid,
        },
        data: {},
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('查询成功')
        if (type == 0) {
          this.userInfo.head = res.data.headIcon
          this.userInfo.name = res.data.name
        } else {
          this.userInfo.inviteHead = res.data.headIcon
          this.userInfo.inviteName = res.data.name
        }
      }
    },
    async bind() {
      if (!this.search.rid || !this.search.inviteRid) {
        return this.$message.error('rid或inviteRid不能为空')
      }
      const { data: res } = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.invite_mgr_bind,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid: this.search.rid,
          invitedRid: this.search.inviteRid,
        },
      })
      this.msg = res.msg
      if (res.status != 0 || res.code != 0) {
        return (this.msg = res.message || res.msg)
      } else {
        this.$message.success('绑定成功')
        this.msg = 'success'
        this.search = {
          rid: null,
          inviteRid: null,
        }
        this.userInfo = {
          head: '',
          name: '',
          inviteHead: '',
          inviteName: '',
        }
        this.msg = ''
      }
    },
  },
}
</script>
<style scoped lang="scss">
.inviteMgr {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    display: flex;
    align-items: center;
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }

    .avatar {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #ccc;
      margin: 0 10px;
      img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
      }
    }
  }
}
</style>